<template>
  <div
    v-show="show"
    class="modal fade"
    :class="[{ 'show d-block': show }, { 'd-none': !show }, { 'modal-mini': type === 'mini' }]"
    tabindex="-1"
    role="dialog"
    :aria-hidden="!show"
    @click.self="closeModal"
  >
    <div
      class="modal-dialog"
      :class="[{ 'modal-notice': type === 'notice' }, modalClasses]"
    >
      <div class="modal-content">
        <div
          class="modal-header"
          :class="headerClasses"
        >
          <slot name="close-button">
            <button
              v-if="showClose"
              type="button"
              class="close"
              data-dismiss="modal"
              :aria-hidden="!show"
              @click="closeModal"
            >
              <i class="now-ui-icons ui-1_simple-remove" />
            </button>
          </slot>
          <slot name="header" />
        </div>

        <div
          class="modal-body"
          :class="bodyClasses"
        >
          <slot />
        </div>

        <div
          class="modal-footer"
          :class="footerClasses"
        >
          <slot name="footer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { watch } from 'vue';

export default {
  name: 'Modal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: '',
      validator(value: string) {
        let acceptedValues = ['', 'notice', 'mini'];
        return acceptedValues.indexOf(value) !== -1;
      },
      description: 'Modal type (notice|mini|"") ',
    },
    modalClasses: {
      type: [String, Object],
      default: '',
      description: 'Modal dialog css classes',
    },
    headerClasses: {
      type: [String, Object],
      default: '',
      description: 'Modal Header css classes',
    },
    bodyClasses: {
      type: [String, Object],
      default: '',
      description: 'Modal Body css classes',
    },
    footerClasses: {
      type: [String, Object],
      default: '',
      description: 'Modal Footer css classes',
    },
    animationDuration: {
      type: Number,
      default: 500,
      description: 'Modal transition duration',
    },
  },
  emits: ['update:show', 'close'],
  setup: (props: any, context: any) => {
    const { emit } = context;

    const closeModal = () => {
      emit('update:show', false);
      emit('close');
    };

    watch(
      () => props.show,
      (value: boolean) => {
        let documentClasses = document.body.classList;
        if (value) {
          documentClasses.add('modal-open');
        } else {
          documentClasses.remove('modal-open');
        }
      },
    );

    return {
      closeModal,
    };
  },
};
</script>

<style>
.modal.show {
  background-color: rgba(0, 0, 0, 0.3);
}
</style>
